import { render, staticRenderFns } from "./dipatch-profit.vue?vue&type=template&id=646d0dea&"
import script from "./dipatch-profit.vue?vue&type=script&lang=js&"
export * from "./dipatch-profit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports